module.exports = __webpack_public_path__ + "static/media/print-sgombero-detail5.bdb3b868.jpg";